import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { SmartFormInputDate } from '../../../form/FormInputDate';
import FormInputText from '../../../form/FormInputText';
import FormPasswordInputText from '../../../form/FormPasswordInputText';
import { Button, Text } from '../../../ui';
import { FlexContainer } from '../../../ui/Container';
import { WizardFormData } from '../types';

interface UserDetailsStepProps {
  onNext: () => void;
  onBack: () => void;
}

const UserDetailsStep: FC<UserDetailsStepProps> = ({ onNext, onBack }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<WizardFormData>();

  return (
    <FlexContainer flexDirection="column" gap="md" align="center" style={{ maxWidth: '500px', margin: '0 auto' }}>
      <FlexContainer flexDirection="column" align="center" gap="xxs">
        <Text weight="semibold" size="lg" style={{ textAlign: 'center' }}>
          Tell us about yourself
        </Text>
        <Text color="textSecondary" size="sm" style={{ textAlign: 'center' }}>
          Enter your personal details to create your account
        </Text>
      </FlexContainer>

      <FlexContainer flexDirection="column" gap="sm" style={{ width: '100%' }}>
        <FlexContainer gap="sm" style={{ width: '100%' }}>
          <div style={{ flex: 1 }}>
            <FormInputText control={control} errors={errors} name="firstName" placeholder="First Name" />
          </div>
          <div style={{ flex: 1 }}>
            <FormInputText control={control} errors={errors} name="lastName" placeholder="Last Name" />
          </div>
        </FlexContainer>

        <FormInputText control={control} errors={errors} name="email" placeholder="Email Address" type="email" />

        <FormInputText control={control} errors={errors} name="phone" placeholder="Phone Number" type="tel" />

        <SmartFormInputDate
          control={control}
          errors={errors}
          name="dateOfBirth"
          placeholder="Date of Birth"
          outputFormat="date-object"
        />

        <FormPasswordInputText control={control} errors={errors} name="password" placeholder="Password" />

        <Text size="tiny" color="textSecondary" style={{ marginTop: '-8px' }}>
          Password must be at least 8 characters with uppercase, lowercase, and a number
        </Text>
      </FlexContainer>

      <FlexContainer gap="sm" justify="center" style={{ marginTop: '8px' }}>
        <Button type="button" color="transparent" textColor="textSecondary" onClick={onBack}>
          Back
        </Button>
        <Button type="button" color="primary" onClick={onNext} style={{ minWidth: '150px' }}>
          Continue
        </Button>
      </FlexContainer>
    </FlexContainer>
  );
};

export default UserDetailsStep;
